import { url } from '@/helpers/UrlHelpers';
import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class GetSources {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * GetSources constructor.
     *
     * @param {ApiService|null} apiService
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);
    }

    /**
     * Get available canvasser sources from API.
     *
     * @param {Number|null} parentId
     *
     * @return {Promise}
     */
    handle(parentId = null) {
        const apiUrl = parentId ? url(ApiEndpoints['canvasser.sources.show'], [parentId]) : ApiEndpoints['canvassers.sources.index'];

        return this.apiService.get(apiUrl);
    }
}
